<template>
  <b-container fluid>
    <b-row class="mx-0">
      <b-col class="px-0">
        <draggable v-model="subSubTests">
          <transition-group>
            <div
              v-for="(subSubTest, index) in subSubTests"
              :key="subSubTest.id"
              :class="{
                'test': true,

              }"
              @click="$emit('select', subSubTest)"
            >
              <b-row>
                <b-col cols="1">
                  {{ index + 1 }}
                </b-col>
                <b-col cols="3">
                  {{ subSubTest.name }}
                </b-col>
                <b-col cols="1">
                  {{ subSubTest.abbreviation }}
                </b-col>
              </b-row>
            </div>
          </transition-group>
        </draggable>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import draggable from 'vuedraggable'
  export default {
    name: "SubSubTest",
    components: {
      draggable
    },
    props: {
      value: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      subSubTests: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      }
    }
  }
</script>

<style lang="scss"  scoped>
  .test {
    padding: 1rem;
    cursor: pointer;
    text-align: left;
    &:hover {
      background: #dde9ee;
      transition: all 130ms ease-out;
    }

    &.active {
      background: #FB822B;
      color: white;
      transition: all 130ms ease-out;
    }
  }
</style>